import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import FormatQuoteRoundedIcon from '@material-ui/icons/FormatQuoteRounded';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '1rem',
    display: 'flex',
    flexWrap: 'no-wrap',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
  },
  icon: {
    padding: '5px',
    borderRadius: '50%',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.tealish,
  },
  container: {
    marginLeft: '1rem',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
  },
  content: {
    width: '100%',
    fontStyle: 'italic',
  }
}));

const QuoteCard = ({author, content}) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <FormatQuoteRoundedIcon className={classes.icon} fontSize="large"/>
      <div className={classes.container}>
        <Typography variant="body2" className={classes.content}>
          {content}
        </Typography>
        <Typography variant="subtitle2" color="primary" className={classes.author}>
          {author}
        </Typography>
      </div>
    </div>
  );
};

QuoteCard.propTypes = {
  author: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
};

export default QuoteCard;
